import type {
  BodyItemClassNameFunction as externalBodyItemClassNameFunction,
  BodyRowClassNameFunction as externalBodyRowClassNameFunction,
  Header as externalHeader,
  HeaderItemClassNameFunction as externalHeaderItemClassNameFunction,
  Item as externalItem,
} from '../../internal-data-table';
import type { Filter } from '../../store';
import type { FilterTypes } from '../../utils';
import type { TableExportAction } from '../filters/TableTopBar/TableTopBar.types';
// biome-ignore lint/suspicious/noExplicitAny: <intentionally any>
export type ClickRowArgument<T extends Record<string, any>> = T & {
  isSelected?: boolean;
};
export type BodyItemClassNameFunction = externalBodyItemClassNameFunction;
export type HeaderItemClassNameFunction = externalHeaderItemClassNameFunction;
export type BodyRowClassNameFunction = externalBodyRowClassNameFunction;
export type CustomBodyRowClassName =
  | string
  // biome-ignore lint/suspicious/noExplicitAny: <intentionally any>
  | ((item: any, rowNumber: number) => string | undefined | null);
export enum SortType {
  ASC = 'asc',
  DESC = 'desc',
}

export type Column = externalHeader & {
  align?: 'left' | 'center' | 'right';
  filterable?: boolean;
  searchable?: boolean;
  sortFieldName?: string;
  lastFixed?: boolean;
  showIf?: () => boolean;
};

export type Item = externalItem;

export type DataTableProps = {
  class?: string;
  tableTitle?: string;
  mustSort?: boolean;
  headers: Column[];
  items: Item[];
  loading?: boolean;
  alternating?: boolean;
  clickableRows?: boolean;
  borderCell?: boolean;
  selectable?: boolean;
  showIndex?: boolean;
  fixedCheckbox?: boolean;
  checkboxColumnWidth?: number;
  hideSelectAll?: boolean;
  fixedIndex?: boolean;
  indexColumnWidth?: number;
  rowsPerPage?: number;
  tableMinHeight?: number;
  autoHeight?: boolean;
  hideGeneralFilter?: boolean;
  sortBy?: string;
  sortType?: SortType;
  height?: number;
  maxItemsSelectable?: number;
  entityName?: string;
  hideTextSearch?: boolean;
  filtersConfig?: Filter[];
  compactFilters?: boolean;
  filterNamespace?: string;
  searchFieldPlaceholder?: string;
  searchFieldName?: string | FilterTypes.TEXT_SEARCH;
  hideableColumns?: boolean;
  columnVisibilityNamespace?: string;
  nonHideableColumns?: string[];
  bodyRowClassName?: CustomBodyRowClassName;
  disabledReason?: string;
  exportAction?: TableExportAction;
};
